// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__jOAK1","messages":"Chat_messages__3JTY0","dateDivider":"Chat_dateDivider__1Thdi"};